import { Checkbox } from "primereact/checkbox";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoreTagPrinter, getStorePOSEnabled, getUserData, getStorePOSTagPrinterValue } from "../../utils/localStorage";
import {
  getQrCodeImageLink,
  getQrCodeImages,
  getQrCodeImages2,
  getQrCodeServiceWiseHtml,
  getQrCodeServiceWiseImages,
  printedQrCodeImages,
} from "../../services/QrCode/getQrCodeImages";
import StoreMenu from "../StoreMenu";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

import qz from "qz-tray";
import { InputText } from "primereact/inputtext";
import ButtonLink from "../../ButtonLink";
import AdminMenu from "../AdminMenu";

const ViewQrCode = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { storeIdValue, storeCustomerId, bookingOrderId, navigateThrough } =
    location.state || {}; // Fallback to prevent undefined errors

  const { storeData, userProfileRole } = getUserData();

  const storeId = storeData.id;
  const userRole = userProfileRole;

  const [orderQrCodeImage, setOrderQrCodeImage] = useState(null); // Initialize with null or ""
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [visible, setVisible] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [qrCodeServiceWiseData, setQrCodeServiceWiseData] = useState({});
  const [qrCodeServiceWiseHtmlData, setQrCodeServiceWiseHtmlData] = useState({})
  const [orderQrCodeImageLink, setOrderQrCodeImageLink] = useState({})

  let tagMap = new Map();
  const fetchQrCode = () => {
    getQrCodeImages2(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // Sort the keys if they have a numerical order or pattern
          const qrCodeImages = Object.keys(Res).map((key) => ({
            id: Res[key].key,
            base64: Res[key].values,
            checked: true,
          }));
          setOrderQrCodeImage(qrCodeImages);

          const newSelectedQrCodes = qrCodeImages
            .filter((qr) => qr.checked)
            .map((qr) => qr.id);

          // Update selected QR codes
          setSelectedQrCodes(newSelectedQrCodes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchQrCodeImagesLink = () => {
    getQrCodeImageLink(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // Sort the keys if they have a numerical order or pattern
          const qrCodeImages = Object.keys(Res).map((key) => ({
            id: Res[key],
            link: Res[key],
            checked: true,
          }));
          // setOrderQrCodeImageLink(qrCodeImages);

          const newSelectedQrCodes = qrCodeImages
            .filter((qr) => qr.checked)
            .map((qr) => qr.id);

          // Update selected QR codes
          setOrderQrCodeImageLink(newSelectedQrCodes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const [orderQrCodeHtml, setOrderQrCodeHtml] = useState("");
  const [selectedQrCodesHtml, setSelectedQrCodesHml] = useState("");

  const fetchQrCodeHtml = () => {
    getQrCodeImages(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // Sort the keys if they have a numerical order or pattern
          const qrCodeImages = Object.keys(Res).map((key, values) => ({
            id: key,
            base64: Res[key],
            checked: true,
          }));
          setOrderQrCodeHtml(qrCodeImages);

          const newSelectedQrCodes = qrCodeImages
            .filter((qr) => qr.checked)
            .map((qr) => qr.id);

          // Update selected QR codes
          setSelectedQrCodesHml(newSelectedQrCodes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const ServiceQrCode = () => {
    getQrCodeServiceWiseImages(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setQrCodeServiceWiseData(Res.serviceWise);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  const ServiceQrCodeHtml = () => {
    getQrCodeServiceWiseHtml(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setQrCodeServiceWiseHtmlData(Res.serviceWise);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const categories = Object.keys(qrCodeServiceWiseData).map((category) => ({
    label: category,
    value: category,
  }));

  const renderQrCode = () => {
    return orderQrCodeImage?.map((item) => (
      <div>
        <div className="p-2 ">
          <div className="flex flex-1 justify-content-center">
            <img src={`data:image/png;base64,${item.base64}`} />
          </div>
        </div>
      </div>
    ));
  };

  const [tagPrinterValue, setTagPrinterValue] = useState("");

  const fetchSelectedTagPrinter = async () => {
    try {
      const selectedTagPrinterData = await getStoreTagPrinter();
      setTagPrinterValue(selectedTagPrinterData?.tagPrinter || "");
    } catch {
      setTagPrinterValue("");
    }
  };

  const [storePOSEnabledValue, setStorePOSEnabledValue] = useState("");
  const [tagPrinterPOSValue, setTagPrinterPOSValue] = useState("");

  const fetchStorePOSMachine = async () => {
    try {
      const selectedTagPrinterData = await getStorePOSEnabled();

      const value =
        selectedTagPrinterData?.storePOSEnabled === true ||
        selectedTagPrinterData?.storePOSEnabled === "true";

      setStorePOSEnabledValue(value);
    } catch {
      setStorePOSEnabledValue(false);
    }
  };

  const fetchSelectedPOSTagPrinterValue = async () => {
      try {
        const tagPrinterPOSValue = await getStorePOSTagPrinterValue();
        setTagPrinterPOSValue(tagPrinterPOSValue?.tagPrinterPOSValue || "");
      } catch {
        setTagPrinterPOSValue("");
      }
    };

  const [isConnected, setIsConnected] = useState(false);
  // const [printerList, setPrinterList] = useState([]);

  // useEffect(() => {
  //   connectToQZ();
  // }, []);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  useEffect(() => {
    fetchQrCodeImagesLink()
    fetchQrCode();
    fetchQrCodeHtml();
    ServiceQrCode();
    ServiceQrCodeHtml();
    fetchSelectedTagPrinter();
    fetchStorePOSMachine();
    fetchSelectedPOSTagPrinterValue();
    if (!isConnected) {
      connectToQZ();
    }
  }, [storeCustomerId, storeId, bookingOrderId]); // Add dependencies here

  // const findPrinters = async () => {
  //   try {
  //     const printers = await qz.printers.find();
  //     setPrinterList(printers);
  //   } catch (err) {
  //     console.error("Failed to find printers:", err);
  //   }
  // };

  // const printImage = async () => {
  //   try {
  //     const printer = await qz.printers.find("POS-80"); // Replace with your actual printer name

  //     // Set custom size for the image in pixels (width x height)
  //     const config = qz.configs.create(printer, {
  //       rasterize: true,
  //       pxWidth: 584, // Common width for 80mm printers (~2 inches @ 203 dpi)
  //       pxHeight: 200 // Customize this as needed
  //     });

  //     // Load base64 image from state/prop (already prepared)
  //     const base64 = orderInvoice.invoice;

  //     const data = [
  //       {
  //         type: "image",
  //         format: "base64",
  //         data: base64,
  //       },
  //     ];

  //     await qz.print(config, data);
  //     alert("Image sent to printer!");
  //   } catch (err) {
  //     console.error("Print failed:", err);
  //     alert("Failed to print image");
  //   }
  // };

  // const [pageRange, setPageRange] = useState("1");

  // const printImage = async () => {
  //   try {
  //     const printer = await qz.printers.find(tagPrinterValue); // Use your actual printer name

  //     const config = qz.configs.create(printer, {
  //       size: { width: 2, height: 3 },
  //       units: "in",
  //       density: "300",
  //       colorType: "grayscale",

  //       copies: 1,
  //       jobName: "Print Job",
  //       spool: true,
  //       pageRange: pageRange.trim() || "all" // fallback to 'all' if empty
  //     });

  //     // Construct print data array from your QR image list

  //     let data = [];

  //     if (selectedCategory && qrCodeServiceWiseData[selectedCategory]) {
  //       data = Object.values(qrCodeServiceWiseData[selectedCategory]).map((item) => ({
  //         type: "pixel",
  //         format: "image",
  //         flavor: "base64",
  //         data: item.values, // Make sure this is a base64 string without the data URI prefix
  //       }));
  //     } else {
  //       data = orderQrCodeImage.map((item) => ({
  //         type: "pixel",
  //         format: "image",
  //         flavor: "base64",
  //         data: item.base64, // Already stripped of "data:image/png;base64,"
  //       }));
  //     }

  //     if (!data.length) {
  //       alert("No images to print.");
  //       return;
  //     }

  //     await qz.print(config, data);
  //     alert("All QR codes sent to printer!");
  //   } catch (err) {
  //     console.error("Print failed:", err);
  //     alert("Failed to print image(s)");
  //   }
  // };

  const [pageRange, setPageRange] = useState(""); // Example: "1,3,5-7"

  const parsePageRange = (rangeStr) => {
    const parts = rangeStr.split(",");
    const indices = new Set();

    parts.forEach((part) => {
      if (part.includes("-")) {
        const [start, end] = part.split("-").map(Number);
        for (let i = start; i <= end; i++) {
          indices.add(i - 1); // convert to 0-based index
        }
      } else {
        const idx = Number(part) - 1;
        if (!isNaN(idx)) indices.add(idx);
      }
    });

    return Array.from(indices).filter((i) => i >= 0);
  };

  const printImage = async () => {
    try {
      const printer = await qz.printers.find(tagPrinterValue); // Use your actual printer name

      const config = qz.configs.create(printer, {
        size: { width: 2, height: 3 },
        units: "in",
        density: "300",
        colorType: "grayscale",
        copies: 1,
        jobName: "Print Job",
        spool: true,
      });

      let data = [];

      let indicesToPrint = parsePageRange(pageRange);

      if (selectedCategory && qrCodeServiceWiseData[selectedCategory]) {
        const serviceData = Object.values(
          qrCodeServiceWiseData[selectedCategory]
        );

        // If no indices specified, default to all serviceData indices
        if (indicesToPrint.length === 0) {
          indicesToPrint = serviceData.map((_, index) => index);
        }

        data = serviceData
          .filter((_, index) => indicesToPrint.includes(index))
          .map((item) => ({
            type: "pixel",
            format: "image",
            flavor: "base64",
            data: item.values,
          }));
      } else {
        // Fallback to orderQrCodeImage
        if (indicesToPrint.length === 0) {
          indicesToPrint = orderQrCodeImage.map((_, index) => index);
        }

        data = orderQrCodeImage
          .filter((_, index) => indicesToPrint.includes(index))
          .map((item) => ({
            type: "pixel",
            format: "image",
            flavor: "base64",
            data: item.base64,
          }));
      }

      if (!data.length) {
        alert("No images matched the selected page numbers.");
        return;
      }

      await qz.print(config, data);
      setPageRange(""); // Reset input
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print image(s)");
    }
  };

  // const printImage = async () => {
  //   try {
  //     const printer = await qz.printers.find(tagPrinterValue); // Use your actual printer name

  //     const config = qz.configs.create(printer, {
  //       size: { width: 2, height: 3 },
  //       units: "in",
  //       density: "300",
  //       colorType: "grayscale",
  //       copies: 1,
  //       jobName: "Print Job",
  //       spool: true,
  //     });

  //     let data = [];

  //     const indicesToPrint = parsePageRange(pageRange);

  //     if (selectedCategory && qrCodeServiceWiseData[selectedCategory]) {
  //       const serviceData = Object.values(
  //         qrCodeServiceWiseData[selectedCategory]
  //       );
  //       data = serviceData
  //         .filter((_, index) => indicesToPrint.includes(index))
  //         .map((item) => ({
  //           type: "pixel",
  //           format: "image",
  //           flavor: "base64",
  //           data: item.values,
  //         }));
  //     } else {
  //       data = orderQrCodeImage
  //         .filter((_, index) => indicesToPrint.includes(index))
  //         .map((item) => ({
  //           type: "pixel",
  //           format: "image",
  //           flavor: "base64",
  //           data: item.base64,
  //         }));
  //     }

  //     if (!data.length) {
  //       alert("No images matched the selected page numbers.");
  //       return;
  //     }

  //     await qz.print(config, data);
  //     setPageRange("")
  //     // alert("Selected QR codes sent to printer!");
  //   } catch (err) {
  //     console.error("Print failed:", err);
  //     alert("Failed to print image(s)");
  //   }
  // };

  const printInvoiceHTML = async () => {
    try {
      const printer = await qz.printers.find(tagPrinterValue); // Use your actual printer name

      const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        // size: { width: 2 },
        units: "in",
        density: "300",
        colorType: "grayscale",
      });

      let data = [];

      let indicesToPrint = parsePageRange(pageRange);

      if (selectedCategory && qrCodeServiceWiseHtmlData[selectedCategory]) {
        const serviceData = Object.values(
          qrCodeServiceWiseHtmlData[selectedCategory]
        );

        // If no indices specified, default to all serviceData indices
        if (indicesToPrint.length === 0) {
          indicesToPrint = serviceData.map((_, index) => index);
        }

        data = serviceData
          .filter((_, index) => indicesToPrint.includes(index))
          .map((item) => ({
            type: "html",
            format: "plain",
            data: item.values,
          }));
      } else {
        // Fallback to orderQrCodeImage
        if (indicesToPrint.length === 0) {
          indicesToPrint = orderQrCodeHtml.map((_, index) => index);
        }

        data = orderQrCodeHtml
          .filter((_, index) => indicesToPrint.includes(index))
          .map((item) => ({
            type: "html",
            format: "plain",
            data: item.base64.values,
          }));
      }

      if (!data.length) {
        alert("No images matched the selected page numbers.");
        return;
      }

      await qz.print(config, data);

      setPageRange(""); // Reset input
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print image(s)");
    }
  };

  // const printPOSImage = () => {
  //   const imgUrl = encodeURIComponent("https://dhobicart.in/store/api/secure/v1/qr-code/37749/view-qr");
  //     window.location.href =
  //       `bluprintlabelutility://share/open?type=imageUrl&data=${imgUrl}&scale=2`;


  // }

  function printPOSImage() {

    const urls = orderQrCodeImageLink;

    const payload = JSON.stringify(urls);
    const imgUrl = encodeURIComponent(payload);
    // window.location.href =
    //   `bluprintlabelutility://share/open?type=imageUrl&data=${imgUrl}&scale=2`;

    window.location.href =
      `bluprintlabelutility://share/open?type=imageUrl&data=${imgUrl}&scale=2&printer-id=${tagPrinterPOSValue}&printer-type=LABEL`;
  }

  // const printPOSImage = () => {
  //   const encodedUrls = orderQrCodeImageLink
  //     .map(url => encodeURIComponent(url))
  //     .join(",");

  //   window.location.href =
  //     `bluprintlabelutility://share/open?type=imageUrl&data=${encodedUrls}&scale=2`;
  // };

  // const printPOSImage = () => {
  //   let index = 0;

  //   const printNext = () => {
  //     if (index >= orderQrCodeImageLink.length) return;

  //     const imgUrl = encodeURIComponent(orderQrCodeImageLink[index]);

  //     window.location.href =
  //       `bluprintlabelutility://share/open?type=imageUrl&data=${imgUrl}&scale=2`;

  //     index++;

  //     // Delay before sending next QR (adjust timing if needed)
  //     setTimeout(printNext, 5000);
  //   };

  //   printNext();
  // };



  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    userRole === "BY_ADMIN" || userRole === "BY_FRANCHISE_ADMIN"
                      ? navigateThrough === "GoBack"
                        ? navigate(-1)
                        : navigate("/OrdersGarmentInfo", {
                          state: {
                            storeIdValue: storeIdValue,
                            bookingOrderId: bookingOrderId,
                            storeCustomerId: storeCustomerId,
                          },
                        })
                      : navigateThrough === "GoBack"
                        ? navigate(-1)
                        : navigate("/OrdersGarmentInfo", {
                          state: {
                            bookingOrderId: bookingOrderId,
                            storeCustomerId: storeCustomerId,
                          },
                        });
                  }}
                  // onClick={() =>
                  //   navigate("/OrdersGarmentInfo", {
                  //     state: {
                  //       bookingOrderId: bookingOrderId,
                  //       storeCustomerId: storeCustomerId,
                  //     },
                  //   })
                  // }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p
                className="text-white text-2xl font-bold uppercase relative "
                style={{ top: "2px" }}
              >
                Order Tags
              </p>
            </div>
          </div>
          {tagPrinterValue && (
            <div className="flex">
              <div className="flex-1 mt-1">
                <InputText
                  placeholder="Enter Page No. e.g. 1,3-5,7"
                  value={pageRange}
                  maxLength={250}
                  onChange={(e) => setPageRange(e.target.value)}
                  className=" border-none px-3 text-md w-full"
                  style={{ height: 30 }}
                ></InputText>
              </div>
              <div className="mx-4 cursor-pointer" onClick={printInvoiceHTML}>
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>
          )}
          {/* <div className="flex">
            <div className="mx-4 cursor-pointer" onClick={printInvoiceHTML}>
              <img
                src={"images/printer.png"}
                style={{
                  width: 65,
                }}
              />
            </div>
          </div> */}

          {storePOSEnabledValue && orderQrCodeImage?.length > 0 && (
            <div className="flex justify-content-center align-items-center cursor-pointer">
              <Button
                label="POS Print"
                onClick={() => printPOSImage()}
                className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
                style={{
                  color: "#2B70D7",
                  backgroundColor: "#fff",
                  borderColor: "#2B70D7",
                }}
              ></Button>
            </div>
          )}

          {!storePOSEnabledValue && <div className="flex justify-content-center align-items-center cursor-pointer mx-3">
            <Button
              label="ALL"
              onClick={() => {
                fetchQrCode();
                setSelectedCategory("");
              }}
              className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
              style={{
                color: !selectedCategory ? "#fff" : "#2B70D7",
                backgroundColor: !selectedCategory ? "green" : "#fff",
                borderColor: "#2B70D7",
              }}
            ></Button>
          </div>}
          {!storePOSEnabledValue && <div className="mx-3 w-2 QrCodeTag-dropdown">
            <Dropdown
              value={selectedCategory}
              options={categories}
              onChange={(e) => setSelectedCategory(e.value)}
              placeholder="Select a Service"
              className="w-full  border-round-lg m-1"
              style={{ height: 30 }}
            />
          </div>}
          {!storePOSEnabledValue && <div className="flex justify-content-center align-items-center cursor-pointer mx-3">
            {orderQrCodeImage?.length > 0 && (
              <div onClick={() => window.print()}>
                <img
                  src={"Icons/printer.png"}
                  style={{
                    width: 35,
                    cursor: "pointer",
                  }}
                />
              </div>
            )}
          </div>}
          <div
            className="flex justify-content-center align-items-center cursor-pointer ml-3"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>
      <div
        className="h-screen scroll-bar mb-2 flex"
        style={{
          overflowY: "scroll",
          backgroundColor: "#f5f5f5",
        }}
      >
        {selectedCategory ? (
          <div className="flex-1 print-section">
            {Object.values(qrCodeServiceWiseData[selectedCategory]).map(
              (item, index) => (
                <div className="p-2 ">
                  <div className="flex flex-1 justify-content-center">
                    <img src={`data:image/png;base64,${item.values}`} />
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="flex-1 print-section">{renderQrCode()}</div>
        )}

        {/* <div className="mr-4 mt-4">
          {orderQrCodeImage?.length > 0 && (
            <div onClick={() => window.print()}>
              <img
                src={"Icons/printer.png"}
                style={{
                  width: 65,
                  cursor: "pointer",
                }}
              />
            </div>
          )}
        </div> */}
        {orderQrCodeImage?.length > 0 && selectedQrCodes.length === 0 && (
          <div
            style={{
              position: "absolute",
              right: 35,
              top: 75,
            }}
          >
            <img
              src={"Icons/lock.png"}
              style={{
                width: 35,
                height: 35,
                backgroundColor: "transparent",
              }}
            />
          </div>
        )}
      </div>
      <div></div>

      {userRole === "BY_STORE" ?
        <StoreMenu setVisible={setVisible} visible={visible} />
        :
        <AdminMenu setVisible={setVisible} visible={visible} />
      }
      <ButtonLink />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
             .print-section-hide {
              visibility: none;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
            @page {
              size: A4 portrait;
              margin: 10mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ViewQrCode;
